const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2026 Aina Eco. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
